<nav class="fixed top-0 w-full py-1 px-10 flex justify-between shadow-md bg-white z-50">
    <div class="flex items-center cursor-pointer" (click)="onClickLogo()">
        <img src="assets/img/Logo.png" alt="Westhetics" class="w-1/3">
    </div>
    <div class="flex items-center text-nowrap">
        <button class="w-full py-2 px-4 text-left hover:bg-neutral-100" (click)="redirectToLogin()">Login</button>
    </div>
</nav>
